module.exports = __webpack_public_path__ + "static/media/info.e6e30eb9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/AudienceBuilder/assets/info.svg
// module id = 7625
// module chunks = 0